var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isLogged
        ? _c(
            "div",
            {
              staticClass:
                "h-screen flex w-full bg-img vx-row no-gutter items-center justify-center",
              style: {
                "background-image": "url(" + _vm.imagenFondo + ") !important",
                "background-attachment": "fixed",
                overflow: "scroll"
              },
              attrs: { id: "management" }
            },
            [
              _vm.ingresoLogo
                ? _c("img", {
                    style: _vm.logoStyle,
                    attrs: {
                      src: _vm.ingresoLogo.imagen,
                      id: "logo",
                      alt: "logo"
                    }
                  })
                : _vm._e(),
              _vm.fileOnFlow.ejecucion
                ? _c("b-card", { staticClass: "bg-card-grey" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-1 position-relative text-center" },
                        [
                          _vm.fileOnFlow.documentos.length
                            ? _c(
                                "div",
                                { staticClass: "container-attachment" },
                                [
                                  _vm._l(_vm.fileOnFlow.documentos, function(
                                    attachment
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: attachment.adjuntoUrl,
                                        staticClass: "box-attachments"
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass:
                                              "btn-icon mt-2 text-center shadow",
                                            attrs: {
                                              variant: "outline-warning",
                                              "data-cy": "attachment"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.selectFile(
                                                  attachment
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("feather-icon", {
                                              attrs: { icon: "FileTextIcon" }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }),
                                  _vm.isAvailableSign && !_vm.signed
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "position-fixed manage-comments text-left m-auto"
                                        },
                                        [
                                          _c(
                                            "h6",
                                            {
                                              staticClass: "my-2",
                                              staticStyle: {
                                                "font-size": "12px"
                                              }
                                            },
                                            [_vm._v(" Hey, estampa!! ")]
                                          ),
                                          _c(
                                            "b-button",
                                            {
                                              ref: "signPosition",
                                              staticClass:
                                                "btn-icon rounded-circle shadow-lg sign-file",
                                              attrs: {
                                                variant: "warning",
                                                "data-cy": "stamp"
                                              },
                                              on: { click: _vm.setSign }
                                            },
                                            [
                                              _c("feather-icon", {
                                                attrs: { icon: "FeatherIcon" }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            : _vm._e()
                        ]
                      ),
                      _c("div", { staticClass: "col-7" }, [
                        _vm.selectedFile
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.selectedFile.adjuntoUrl,
                                  target: "_blank"
                                }
                              },
                              [
                                _c(
                                  "h5",
                                  {
                                    staticClass:
                                      "text-primary underline d-inline-block mr-2",
                                    attrs: { "data-cy": "document-viewer" }
                                  },
                                  [
                                    _vm._v(
                                      " * Visualizando documento seleccionado " +
                                        _vm._s(_vm.selectedFile.objetoNombre) +
                                        " "
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(
                                            _vm.selectedFile.objetoNombre
                                          ) +
                                          ")"
                                      )
                                    ]),
                                    _vm._v(" * ")
                                  ]
                                ),
                                _c("feather-icon", {
                                  attrs: { icon: "ExternalLinkIcon" }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.selectedFile
                          ? _c("div", { staticClass: "shadow bg-gray" }, [
                              _vm.fileType === "pdf"
                                ? _c(
                                    "div",
                                    { staticClass: "d-flex" },
                                    [
                                      _c("PdfViewport", {
                                        ref: "pdfSignaturePerson",
                                        attrs: {
                                          s3url: _vm.selectedFile.adjuntoUrl,
                                          name: _vm.selectedFile.objetoNombre,
                                          signatures: _vm.signatures,
                                          "signature-height":
                                            _vm.signatureHeight,
                                          "signature-width": _vm.signatureWidth,
                                          closable: false
                                        },
                                        on: {
                                          "signature-drag-end":
                                            _vm.onSignatureDragEnd,
                                          loaded: _vm.setSign,
                                          "signature-delete": _vm.closeSign
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.fileType === "image"
                                ? _c(
                                    "div",
                                    [
                                      _c("b-img", {
                                        attrs: {
                                          src: _vm.selectedFile.adjuntoUrl,
                                          fluid: "",
                                          alt: _vm.selectedFile.objetoNombre
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c(
                            "b-card",
                            { staticClass: "shadow border-1 pt-0" },
                            [
                              _c("div", { staticClass: "bg-white pb-2" }, [
                                _vm.fileOnFlow.ejecucion
                                  ? _c(
                                      "h5",
                                      { staticClass: "card-title mb-0" },
                                      [
                                        _vm._v(
                                          " Expediente # " +
                                            _vm._s(
                                              _vm.fileOnFlow.ejecucion.numero
                                            ) +
                                            " en el " +
                                            _vm._s(
                                              _vm.fileOnFlow.ejecucion.nombre
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _c("div", { staticClass: "text-primary" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.fileOnFlow.ejecucion.descripcion
                                      ) +
                                      " "
                                  )
                                ])
                              ]),
                              _c("b-card-body", { staticClass: "p-0" }, [
                                _vm.isAvailableSign && !_vm.signed
                                  ? _c(
                                      "div",
                                      { staticClass: "mt-5" },
                                      [
                                        _c(
                                          "b-overlay",
                                          { attrs: { show: _vm.signing } },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "ripple",
                                                    rawName: "v-ripple.400",
                                                    value:
                                                      "rgba(113, 102, 240, 0.15)",
                                                    expression:
                                                      "'rgba(113, 102, 240, 0.15)'",
                                                    modifiers: { "400": true }
                                                  }
                                                ],
                                                attrs: {
                                                  variant: "outline-success",
                                                  "data-cy": "sign",
                                                  block: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.confirmSignFile()
                                                  }
                                                }
                                              },
                                              [_vm._v(" Firmar ")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c("OtpModalExternal", {
        ref: "otpModal",
        on: { submit: _vm.onOtpSubmit, cancel: _vm.onOtpCancel }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }